<template>
  <section class="quien-hero relative overflow-hidden" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center text-white px-6">
      <span class="eyebrow eyebrow-light mb-5">Conóceme</span>
      <h1 class="hero-title text-5xl md:text-7xl font-bold text-white">¿Quién soy?</h1>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="mt-6 text-base md:text-xl text-white/90 max-w-2xl italic font-light">
        Belleza con propósito y dedicación
      </p>
    </div>
  </section>

  <section class="w-full max-w-7xl mx-auto px-6 py-24 flex flex-col md:flex-row items-center gap-14">
    <div class="w-full md:w-1/2 flex justify-center">
      <div class="portrait-frame">
        <img
          src="../assets/nuestramision.jpg"
          alt="Nuestra misión"
          class="portrait-image"
        />
      </div>
    </div>

    <div class="w-full md:w-1/2 md:pl-4 text-center md:text-left">
      <span class="eyebrow mb-3">Mi visión</span>
      <h2 class="font-display text-4xl md:text-5xl text-purple-custom font-semibold mt-3 mb-4">
        Nuestra Misión
      </h2>
      <span class="divider-line mb-7 block mx-auto md:mx-0"></span>
      <p class="text-gray-700 text-base md:text-lg" style="line-height: 1.85;">
        En <strong class="text-purple-custom font-semibold">Jeshu Beauty</strong>, la misión es brindarte servicios de belleza personalizados con un enfoque especial en el arte de la manicure. Como profesional apasionada por el diseño y el estilo, me dedico a crear experiencias únicas que realzan tu belleza natural mientras te sientes cómoda y segura.
      </p>
      <p class="text-gray-700 text-base md:text-lg mt-5" style="line-height: 1.85;">
        Me mantengo constantemente actualizada con las últimas tendencias y técnicas innovadoras, utilizando productos profesionales de alta calidad para garantizar resultados excepcionales que superen tus expectativas.
      </p>
      <p class="text-gray-700 text-base md:text-lg mt-5" style="line-height: 1.85;">
        Mi compromiso es ofrecerte un ambiente acogedor y relajante donde puedas expresar tu estilo personal mientras recibes un servicio profesional y dedicado que te hará sentir hermosa y segura.
      </p>
    </div>
  </section>

  <GoContacto />
</template>

<script>
import backgroundImage from '@/assets/cristal1-scaled.jpg';
import GoContacto from '@/components/GoContacto.vue';
import { useHead } from '@vueuse/head';

export default {
  components: { GoContacto },
  name: 'QuienSoy',
  setup() {
    useHead({
      title: 'Quienes Somos | Servicios de manicure y belleza excepcionales',
      meta: [
        { name: 'description', content: 'La misión de Jeshu Beauty es brindar servicios de manicure y belleza excepcionales que realcen la belleza natural de nuestros clientes y les brinden una experiencia de cuidado y mimo personalizado.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Quienes Somos | Servicios de manicure y belleza excepcionales' },
        { property: 'og:description', content: 'La misión de Jeshu Beauty es brindar servicios de manicure y belleza excepcionales que realcen la belleza natural de nuestros clientes y les brinden una experiencia de cuidado y mimo personalizado.' },
        { property: 'og:url', content: 'https://jeshubeauty.cl/about' },
      ],
      link: [{ rel: 'canonical', href: 'https://jeshubeauty.cl/about' }]
    });
  },
  data() {
    return { backgroundImage };
  },
}
</script>

<style scoped>
.quien-hero {
  height: 55vh;
  min-height: 440px;
  background-size: cover;
  background-position: center;
}

.portrait-frame {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.portrait-frame::before {
  content: '';
  position: absolute;
  inset: -16px -16px 16px 16px;
  border: 2px solid #b8b1bd;
  border-radius: 1.25rem;
  z-index: 0;
  transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.portrait-frame::after {
  content: '';
  position: absolute;
  width: 90px;
  height: 90px;
  top: -32px;
  left: -32px;
  background: linear-gradient(135deg, #734A91 0%, #65209D 100%);
  border-radius: 1rem;
  opacity: 0.85;
  z-index: 0;
}

.portrait-frame:hover::before {
  transform: translate(6px, -6px);
}

.portrait-image {
  position: relative;
  z-index: 1;
  display: block;
  border-radius: 1.25rem;
  object-fit: cover;
  width: 100%;
  max-width: 520px;
  height: 600px;
  box-shadow: 0 24px 60px rgba(17, 12, 24, 0.18);
}

@media (max-width: 768px) {
  .portrait-image {
    height: 460px;
  }
  .portrait-frame::after {
    width: 60px;
    height: 60px;
    top: -22px;
    left: -22px;
  }
}
</style>
